import { StyleSheet } from 'aphrodite';
import type { FC } from 'react';
import { Button } from '../../../web/components-v2/Button';
import {
	Dialog,
	DialogBody,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../web/components-v2/Dialog';

export type ConfirmTakeOverDialogProps = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	/** Take the dialer, ending the call the other tab is on. */
	onConfirm: () => void;
};

/**
 * Asked before moving the dialer off a tab that is on a call, because doing so ends that
 * call. The control that triggers it sits where an idle "move it here" also lives, so a
 * mis-click would otherwise drop a live customer call with no undo.
 *
 * Opened by the rep's own click, never on its own — a tab the dialer does not live in
 * should not interrupt anyone.
 */
export const ConfirmTakeOverDialog: FC<ConfirmTakeOverDialogProps> = ({ open, onOpenChange, onConfirm }) => {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogPopup styles={[styles.popup]}>
				<DialogHeader>
					<DialogTitle>End your call and move the dialer?</DialogTitle>
					<DialogDescription>
						You're on a call in another tab. Only one tab can hold the dialer, so moving it here will end that call.
					</DialogDescription>
				</DialogHeader>
				<DialogBody />
				<DialogFooter>
					<Button variant='secondary' size='lg' onClick={() => onOpenChange(false)}>
						Keep the call
					</Button>
					<Button variant='destructive' size='lg' onClick={onConfirm}>
						End call & move
					</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
};

const styles = StyleSheet.create({
	popup: {
		maxWidth: 440,
	},
});
